import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const PasswordlessLogin: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  const [email, setEmail] = useState('lalit@getswan.co');
  const [isLoading, setIsLoading] = useState(false);

  const handlePasswordlessLogin = async () => {
    if (!email) {
      alert('Please enter your email address');
      return;
    }

    setIsLoading(true);

    try {
      // Force passwordless by specifying connection and using prompt=login to avoid HRD
      await loginWithRedirect({
        authorizationParams: {
          connection: 'email',
          login_hint: email,
        },
      });
    } catch (error) {
      console.error('Login failed:', error);
      setIsLoading(false);
    }
  };

  const handleSocialLogin = async () => {
    await loginWithRedirect();
  };

  return (
    <div
      style={{
        maxWidth: '400px',
        margin: '0 auto',
        padding: '20px',
        textAlign: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '10px',
      }}
    >
      <h2>Sign In</h2>

      <div style={{ marginBottom: '20px' }}>
        <h3>Passwordless Login (Email OTP)</h3>
        <input
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            width: '100%',
            padding: '10px',
            marginBottom: '10px',
            borderRadius: '5px',
            border: '1px solid #ccc',
          }}
        />
        <button
          onClick={handlePasswordlessLogin}
          disabled={isLoading}
          style={{
            width: '100%',
            padding: '10px 20px',
            backgroundColor: '#0070f3',
            color: 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px',
          }}
        >
          {isLoading ? 'Sending...' : 'Send Magic Link'}
        </button>
      </div>

      <div style={{ margin: '20px 0' }}>
        <hr style={{ border: '1px solid rgba(255,255,255,0.3)' }} />
        <span style={{ backgroundColor: '#282c34', padding: '0 10px' }}>
          OR
        </span>
      </div>

      <button
        onClick={handleSocialLogin}
        style={{
          width: '100%',
          padding: '10px 20px',
          backgroundColor: '#28a745',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
        }}
      >
        Sign In with Universal Login
      </button>
    </div>
  );
};
